import {
  dictbasic, //字典
  getDictSystem, //系统字段
  uploadAttachment, //附件上传
  saveAttachment, //保存
  deleteAttachment, //删除附件
  dictList, //省市区等字典
  dictbasicList,//产品分类
  getDealItem,//账单类型
  listDictSystem,//获得下单方式
  getCategory,//获得品类
  banner,//首页banner
  zzCraft,//获得工艺
  zzEmb,//刺绣信息
  zzContrast,//撞色面料
  searchCraft,//搜索工艺
  specBody,//特体信息
  styleInfo,//着装风格
  measureInfo,//尺寸列表
  standard,//尺码类型
  shapeCategory,//尺码类型查标准号
  isAdd,//是否追加西裤
  saveOrder,//保存订单
  getFinishedSize,//订单获取成衣尺寸
  simpleGetFabricStock,//库存
  getCraftPrice,//获得工艺
  getClothSize,//用户新增品类
  failedAmount,//数量
  zzSpecBody,//neworder特体+
  styleSpecBody,//style特体+
  styleStandard,//style字典
  styleMeasureInfo,//style字典
  styleAuthInfo,//style字典量体风格
  calculatePrice,//面料价格
  selectDictBasicTrees,//衬类型
  calculatePriceHeader,//计算价格
} from "@/api/dict.js";
export default {
  state: {

  },
  actions: {
    // 计算价格
    calculatePriceHeaderAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        calculatePriceHeader(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 衬类型
    selectDictBasicTreesAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        selectDictBasicTrees(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 面料价格
    calculatePriceAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        calculatePrice(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    styleMeasureInfoAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        styleMeasureInfo(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    styleAuthInfoAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        styleAuthInfo(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    styleSpecBodyAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        styleSpecBody(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    styleStandardAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        styleStandard(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    dictbasicAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        dictbasic(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    zzSpecBodyAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        zzSpecBody(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 字典
    failedAmountAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        failedAmount(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 客户新增品类
    getClothSizeAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getClothSize(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获的价格
    getCraftPriceAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getCraftPrice(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 库存
    simpleGetFabricStockAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        simpleGetFabricStock(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 订单获取成衣尺寸
    getFinishedSizeAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getFinishedSize(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 保存订单
    saveOrderAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        saveOrder(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 是否追加西裤
    isAddAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        isAdd(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 尺码类型
    standardAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        standard(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 尺码类型查标准号
    shapeCategoryAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        shapeCategory(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 尺寸列表
    measureInfoAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        measureInfo(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 着装风格
    styleInfoAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        styleInfo(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 特体信息
    specBodyAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        specBody(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 搜索工艺
    searchCraftAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        searchCraft(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 撞色面料
    zzContrastAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        zzContrast(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 刺绣信息
    zzEmbAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        zzEmb(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    //工艺
    zzCraftAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        zzCraft(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // banner
    bannerAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        banner(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 下单方式
    listDictSystemAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        listDictSystem(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获得品类
    getCategoryAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getCategory(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 省市区字典
    dictListAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        dictList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 账单类型
    getDealItemAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getDealItem(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获得产品分类
    dictbasicListAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        dictbasicList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 附件上传
    uploadAttachmentAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        uploadAttachment(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 附件删除
    deleteAttachmentAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        deleteAttachment(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 保存当前图片
    saveAttachmentAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        saveAttachment(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 系统字典
    getDictSystemAction({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        getDictSystem(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },

  },
  mutations: {

  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/module/dict.js